import styled from 'styled-components';

export const BlockedNotice = styled.p`
  width: 100%;
  margin-bottom: 1.5rem;
  padding: 0.8rem 1rem;
  border-radius: 0.56rem;
  border-left: 3px solid #ff9800;
  background: rgba(255, 152, 0, 0.08);
  font-family: 'RedHatDisplay-Regular';
  font-size: 0.85rem;
  line-height: 1.5;
  color: #4a4a4a;

  > button {
    background: none;
    border: none;
    padding: 0;
    font-family: 'RedHatDisplay-Bold';
    font-size: inherit;
    color: #1e88e5;
    cursor: pointer;
    text-decoration: underline;

    &:focus-visible {
      outline: 2px solid #1e88e5;
      outline-offset: 2px;
    }
  }
`;
